import "./Navbar.css";
import { useEffect, useState } from "react";
import brandLogo from "../../assets/images/bybebeklogo.png";

function Navbar() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 30);
    };

    window.addEventListener("scroll", handleScroll);

    return () =>
      window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <header className={`navbar ${scrolled ? "scrolled" : ""}`}>
      <div className="container navbar-container">
        <a href="/" className="logo">
          <img src={brandLogo} alt="Bybebek" />
        </a>

        <nav className="nav-links">
          <a href="#security">Güvenlik</a>
          <a href="#app">Mobil Uygulama</a>
        </nav>

        <a
          className="nav-btn"
          href="#waitlist"
        >
          Erken Erişim
        </a>
      </div>
    </header>
  );
}

export default Navbar;
